import { h } from 'preact';
import clsx from 'clsx';
import ClickSelection from '../../threekit-components/click-selection';
import { useThreekit } from '../../threekit-context';
import Image from '../../../utils/image';
import { Swiper, SwiperSlide } from '../swiper';

function HandleDrawerBolster() {
  const { getProductsFromAttribute, getSelectedVariant, darkMode } = useThreekit();

  const products = getProductsFromAttribute('Bolster Color');
  const selectedVariant = getSelectedVariant(products);

  return (
    <div className="laptop:pt-5 laptop:px-5 pl-2.5 py-2.5 justify-center flex">
      <Swiper
        slidesPerView={4}
        spaceBetween={10}
        slidesOffsetAfter={80}
        breakpoints={{
          1024: {
            slidesPerView: 9,
            spaceBetween: 18,
          },
        }}
      >
        {products.map((product) =>
          product.variants.edges.map(
            (variant) =>
              variant.node.configurationEnabled && (
                <SwiperSlide
                  key={`${variant.node.id}-bolster-drawer`}
                  className="min-w-[90px] laptop:min-w-[139px]"
                >
                  <ClickSelection
                    element="button"
                    variant={variant}
                    className={clsx('border-black border-opacity-20 border-2', {
                      'border-white border-opacity-100':
                        selectedVariant === variant && darkMode,
                      'border-black border-opacity-100':
                        selectedVariant === variant && !darkMode,
                    })}
                  >
                    <Image
                      {...variant.node.image}
                      width={140}
                      height={116}
                      alt={
                        variant.node.image.alt
                          ? variant.node.image.alt
                          : variant.node.title
                      }
                    />
                  </ClickSelection>
                </SwiperSlide>
              ),
          ),
        )}
      </Swiper>
    </div>
  );
}

export default HandleDrawerBolster;
